import React from "react";
import styles from "./MiniTag.module.scss";

const COLORS = {
  CREAM: styles.cream,
  GREEN: styles.green,
  GREY: styles.grey,
  GREY_OUTLINE: styles.greyOutline,
  RED: styles.red,
  VIOLET: styles.violet,
}

const SIZES = {
  MEDIUM: styles.mediumSize,
}

const MiniTag = (props) => {
  const { color, size, text, title, className, show = true } = props;

  if (!color || !text || !title || !show) {
    return null;
  }

  const classes = [
    styles.module,
    className,
    color,
    size,
  ];

  return <span className={classes.join(" ")} title={title}>{text}</span>;
}

MiniTag.COLORS = COLORS;
MiniTag.SIZES = SIZES;

MiniTag.defaultProps = {
  size: SIZES.MEDIUM,
}

export default MiniTag;

export const SubscriptionTag = ({show}) => <MiniTag show={show} color={COLORS.GREY} className="icon-subscription" title="Subscription" text="sub" />;
export const NewSubscriptionTag = ({show}) => <MiniTag show={show} color={COLORS.CREAM} className="icon-newsubscription" title="New Subscription" text="sub" />;
export const OneTimeOrderTag = ({show}) => <MiniTag show={show} color={COLORS.GREEN} className="icon-onetime" title="One-time order" text="one" />;
export const SalesTag = ({show}) => <MiniTag show={show} color={COLORS.GREY_OUTLINE} className="icon-sales" title="Sales order" text="SO" />;
export const GiftTag = ({show}) => <MiniTag show={show} color={COLORS.VIOLET} className="icon-gift" title="Sent as gift" text="g" />;
export const ComplimentaryTag = ({show}) => <MiniTag show={show} color={COLORS.GREEN} className="icon-complimentary" title="Complimentary order" text="C" />;
export const DiscountedTag = ({show}) => <MiniTag show={show} color={COLORS.RED} className="icon-discounted" title="Discounted / Promo Code" text="d" />;
export const ReplacementTag = ({show}) => <MiniTag show={show} color={COLORS.GREY} className="icon-replacement" title="Replacement order" text="R" />;
export const ExternalOrderTag = ({show, source}) => {
  let title = "";
  let text = "";

  switch (source) {
    case "facebook":
      title = "Facebook Order";
      text = "FB";
      break;
  
    case "instagram":
      title = "Instagram Order";
      text = "IN";
      break;
  
    default:
      title = "External Order";
      text = "Ext";
      break;
  }
  
  return <MiniTag show={show} color={COLORS.GREEN} className="icon-external-order" title={title} text={text} />;
}